<template>
  <div class="wrapper">
    <div class="main-content">
      <header-title
        title="عن المنصة"
        titlePrevious="الرئيسية "
        color="var(--primary)"
      />

      <section class="container bg-white">
        <div v-if="loadingAbout" class="mt-2 mx-1">
          <b-skeleton animation="fade" width="20%"></b-skeleton>
          <b-skeleton
            v-for="n in 8"
            :key="n"
            animation="fade"
            width="85%"
          ></b-skeleton>
        </div>
        <div class="row" v-else>
          <div class="col-md-12 col-sm-12">
            <div class="Mayor- text-dark">
              <h3 class="font-weight-bolder mb-1 mt-2">
                {{ ngoAboutPlatform.title }}
              </h3>
              <div
                v-html="ngoAboutPlatform.content"
                class="plat-about ngo_about"
              ></div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import { BTable, BNav, BNavItem, BSkeleton } from "bootstrap-vue";
import HeaderTitle from "../../components/HeaderTitle.vue";
export default {
  components: {
    BTable,
    BNav,
    BNavItem,
    BSkeleton,
    HeaderTitle,
  },

  computed: {
    loadingAbout() {
      return this.$store.getters["NgoHome/main/loadingAbout"];
    },
    ngoAboutPlatform() {
      return this.$store.getters["NgoHome/main/ngoAboutPlatform"];
    },
  },
  created() {
    this.$store.dispatch(`NgoHome/main/getAboutPlatform`);
  },
};
</script>

<style lang="scss">
.plat-about {
  h4 {
    font-size: x-large;
    padding: 4px 0px;
  }
  li {
    padding: 4px 0px;
    list-style: disc;
  }
}
</style>
